import { CustomElement } from "@cervval.js/client-html5-core/src/components/customElement.decorator";
import { TypedHtmlElements } from "@cervval.js/client-html5-core/src/components/typedHtmlElements.decorator";
import { WebComponent } from "@cervval.js/client-html5-core/src/components/webComponent";
import { NAVIGATION_SERVICE, NavigationService } from "@cervval.js/client-html5-spa/navigation";
import { CjsButton } from "@cervval.js/client-html5-ui/src/components/button/button";
import { CjsDropdownButton } from "@cervval.js/client-html5-ui/src/components/dropdownButton/dropdownButton";
import { Injected } from "@cervval.js/common/src/dependencies/injected";
import { Debounce } from "@cervval.js/common/src/tools/debounce.decorator";
import { translateHTMLReferences } from "@ehealth_tools/client-html-tools/src/tools/webcomponent.tools";
import { BOOKING_SERVICE } from "@ehealth_tools/common-booking/src/services/abstractCommonBooking.service";
import { PageName } from "../../../core/pages/navigation.config";
import { ClientBookingService } from "../../../shared/services/clientBookingService";
import { _I18nNavHeader } from "./navHeader.i18n";

@CustomElement({
    name: "nav-header",
    style: require("./navHeader.scss"),
    template: require("./navHeader.html"),
    i18n: require("./navHeader.i18n").I18nNavHeader()
})
export class NavHeader extends WebComponent<_I18nNavHeader> {

    @TypedHtmlElements({ ensureLoadedClasses: [CjsDropdownButton, CjsButton] })
    public readonly components!: {
        appLogo: HTMLImageElement,
        refreshBtnContainer: HTMLUListElement,
        persistStatusLed: HTMLElement,
        userLink: HTMLLinkElement,
        connected: HTMLDivElement,
        disconnected: HTMLDivElement,

        login: HTMLDivElement,
        registration: HTMLDivElement,
        /** Link to the profile page of the application */
        profileLink: HTMLAnchorElement,
        /** Link for application logout */
        logoutLink: HTMLAnchorElement,

        navAppButton: HTMLDivElement
    };

    @Injected(NAVIGATION_SERVICE)
    public readonly navigationService!: NavigationService<PageName>;

    @Injected(BOOKING_SERVICE)
    private _bookingService!: ClientBookingService;


    /** init callbacks */
    public override init(): void | Promise<void> {
        this.components.login.addEventListener("click", () => {
            this._bookingService.showLogin();
        });

        translateHTMLReferences(this.components, this.i18n.html);

        this.components.navAppButton.addEventListener("click", () => {
            window.location.href = getProperProUrl(); // This button only works in production 
        });
    }

    /** debounced refreshCurrentPage */
    @Debounce(300)
    protected refreshCurrentPageLater(): void {
        this.navigationService.refreshCurrentPage();
    }


}

/** */
function getProperProUrl(): string {
    const url = window.location;
    // Local dev
    if (url.hostname === "localhost") { return "../activmed"; }
    if (url.hostname.indexOf("dev") >= 0) {
        return "https://dev.activmed.fr/activmed";
    } else {
        return "https://pro.activmed.fr/activmed";
    }
}